import { PipelineRunResponse, VisiblePipelineStage } from "@/types/contract-family-pipeline";
import { buildContractFamiliesPath } from "@/views/contract-families/navigation";

export const visiblePipelineStages: VisiblePipelineStage[] = [
  "categorise_review_confirm",
  "create_snapshots",
  "summarise",
];

export const getAllowedDisplayStage = (
  run: PipelineRunResponse,
  requestedStage: string | null,
): VisiblePipelineStage => {
  const highest = visiblePipelineStages.indexOf(run.highest_available_stage);
  const requested = visiblePipelineStages.indexOf(requestedStage as VisiblePipelineStage);
  return requested >= 0 && requested <= highest ? visiblePipelineStages[requested] : run.visible_stage;
};

export const buildPipelineReturnUrl = (runId: string, stage: VisiblePipelineStage): string =>
  buildContractFamiliesPath(null, { pipelineRunId: runId, stage });

export const buildPipelineReturnPath = (
  folderFseId: string | null | undefined,
  runId: string,
  stage: VisiblePipelineStage,
) => buildContractFamiliesPath(folderFseId, { pipelineRunId: runId, stage });
